export default __webpack_public_path__ + "static/media/relax.0c2192d9.svg";